import { render } from "./LicenseParseErrorList.vue?vue&type=template&id=3b56f5ae"
import script from "./LicenseParseErrorList.vue?vue&type=script&lang=js"
export * from "./LicenseParseErrorList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__